import { exportUser } from "./index";

//服务器
//var url= "https://shixi360.cn/Cloud_Internship";
//var url = "http://2zk3xy.natappfree.cc";
//var url = "http://192.168.1.172:8080";
// var url= "https://shixi360.cn";
export var key = "";
export var grade = "";
export function a(value1, value2, value3, value4) {
  baseURL = value1;
  resourceEnv = value2;
  key = value3;
  grade = value4;
}
//export default
// const apiUrl = {}
export let baseURL = "";
//数据库
export let resourceEnv = ""; //        yusun003-0g5wojdn3be00f15  

export const apiUrl = {
  //修改用户认证a
  upRealUser: "user/auth",
  //用户新增
  userPost: "user/update",
  //用户修改
  userSet: "user/update",
  //修改用户状态
  upUserState: "user/update/status",
  //用户查询
  userGet: "user/list/",
  //用户删除
  userDelete: "user/del/",
  //获取手机验证码
  userCodeGet: "user/phone/",
  //手机验证码登录
  verificationLogin: "login/mobile",
  //判断用户（老师）手机号是否存在
  isStayPhoneGet: "user/eqPhone/",

  //角色删除
  rolesDelete: "roles/del/",
  //查看该学校所有角色
  rolesGet: "roles/list/",
  //新增和修改角色
  rolesPost: "roles/add",
  //查看所有功能模块
  moduleGet: "roles/module/",

  //新增或修改组织
  organizationPost: "school/add",
  //获取组织结构
  organizationGet: "school/",
  //选择年级
  organizationPut: "school/years",

  //查看该校所有班级classPost
  classPut: "class/list",
  //修改班级
  classPost: "class/add",
  //删除班级
  classDelete: "class/del",
  //获取计划下的班级
  planClassGet: "class/list/plan/",
  //导入班级
  classFilePush: "class/import",

  //获取班级学生
  studentGet: "stu/",
  //新增修改学生
  studentPost: "stu/add",
  //导入学生
  studentImportPost: "position/importStudent",
  //导入状态查询
  studentStateImportPost: "stu/importquery",
  //删除学生
  studentDelete: "stu/del",
  //获取导入模板下载链接
  studentImportDownload: "stu/download",

  //新增（修改）基地&企业company/update
  enterprisePost: "company/update",
  //获取该校所有企业
  enterpriseGet: "company/",
  //删除企业
  enterpriseDelete: "company/del",

  //新增（修改）职位
  positionPost: "company/position/update",
  //获取该公司岗位
  positionGet: "company/position/",
  //删除岗位
  positionDelete: "company/position/",

  //查询申请岗位的学生
  applyGetStudent: "practice/",
  //查询申请岗位的学生new
  applyGetStudentNew: "practice/getInvitePosition",
  //获取学生申请的岗位信息
  StudentGetapply: "practice/position",
  ///修改申请状态
  applyGetState: "practice/apply",

  //新增（修改）实习计划
  internshipPost: "practice/update",
  //获取该校所有实习计划
  schoolInternshipGet: "practice/",
  //删除实习计划
  internshipDelete: "practice/del",
  //获取实习计划关联的班级
  internshipClassPost: "practice/class",

  //新增（修改）实习小组
  groupInternshipPost: "practice/group/update",
  //查询实习小组
  groupInternshipGet: "practice/group/",
  //查询可添加的学生
  addSthdentGet: "practice/group/studentadd/",
  //添加学生到实习小组
  addSthdentPost: "practice/group/student",
  //查询实习小组中的学生
  groupInternshipStudentGet: "practice/group/student/",
  //删除实习小组中的学生
  groupInternshipStudentDelete: "practice/group/student",
  //删除实习小组
  groupDelete: "practice/group",

  //获取年份列表
  yearGet: "years/list",
  //删除年度
  gradeDelete: "years/",

  //新增学校管理员
  schoolAdminPost: "admin/account",
  //修改学校和账号信息
  schoolPostPut: "admin/account",
  schoolPostPut2: "admin/account//",
  //查询学校和管理员账号信息
  schoolAdminGet: "admin/account",
  //删除学校管理员账号
  schoolAdminDelete: "admin/account/",

  //注册超级管理员user/add
  registerAdminPost: "user/add",
  //管理员账号登录
  loginAdminPost: "login",

  //获取实习计划周数
  planWeek: "practice/log/date/",
  //实习日志
  planDay: "practice/log/",
  //获取该学生的日志（日报，周报）
  planTaday: "practice/log/detail/",
  //修改多人日志
  changeDaily: "practice/log/status",

  //安全预警(全部)
  studentSafeGet: "safety/list",
  //安全预警(当天)
  tadySafeGet: "teach/safety/",

  //查询请假信息
  AskforleaveGet: "practice/askForLeave/",
  //查询签到信息
  clockinGet: "practice/sign/",
  //查询实习分析
  checkGet: "practice/analysis/",
  //查询收藏
  stpreupGet: "practice/collect/",
  //收藏
  stpreupPost: "practice/collect",
  //取消收藏
  stpreupDelete: "practice/collect",

  //发布安全帖子信息
  addPostsPost: "safety/forum",
  //查询安全帖子信息
  PostsGet: "safety/forum/",
  //删除安全帖子信息
  PostsDelete: "safety/forum",
  //修改安全帖子信息
  PostsPut: "safety/forum",
  //查询签到异常
  getSign: "safety/sign2/",

  //查询电子档案
  getArchives: "archives/",
  //新增协议
  postArchives: "archives/agreement",
  //查询协议
  getArchivesWrite: "archives/agreement/",
  //删除协议
  deleteArchives: "archives/agreement/",

  //新增安全信息   postSafeInfo : "safety/info",  "http://192.168.10.11:8081/safety/addUrl",
  postSafeInfo: "safety/info",
  //删除安全信息
  deleteSafeInfo: "safety/info",
  //查询安全信息
  getSafeInfo: "safety/info/",

  //获取学校背景图
  getSchoolBgd: "login/",

  //导入题目
  KaoshiFile: "safety/question",
  //查看试题
  getKaoshi: "safety/question/",

  //获取二维码
  getTwoCode: "login/qrcode/",
  //获取扫码状态
  getTwoCodeStatus: "login/value/",
  //小程序登录
  getloginMiniApp: "login/miniApp/",

  //发送用户信息
  sendEmailPost: "admin/info/",

  // 我的工作台
  workbenchGet: "teach/",
  //我的工作台-实习计划
  workbenchPlanGet: "teach/plan/",

  //账户设置
  accountPut: "user/settings",

  //实习总结
  summaryGet: "practice/summary/",

  //设置考核占比
  percentPost: "practice/percent",
  //查看考核占比
  practiceGet: "practice/percent",
  //考核成绩
  resultGet: "practice/assessment",
  //导出考核评分
  exportGet: "practice/export",

  kaoshifsGet: "safety/question/score/",
  qingjiabhGet: "practice/leave/",

  //忘记密码
  forgotPwdPost: "login/forgotPwd",
  //签到异常处理
  disposePost: "safety/sign/dispose",
  //处理安全预警
  informPost: "safety/dispose",
  //签到异常处理记录
  UnusualRecordGet: "safety/sign/dispose/",

  //学校试用申请
  applySchool: "school/apply",
  //查看学校试用申请
  applySchoolGet: "admin/apply",
  //删除学校试用申请
  applySchoolDelete: "admin/apply/",
  //导出试用申请
  applySchoolExport: "admin/apply",

  //绑定实习计划
  userPlanPut: "user/plan",
  //提升用户权限
  putPromoteUser: "user/promote",

  //导出异常处理记录
  disposeGet: "safety/export/sign/dispose/",
  //导出实习分析
  analysisGet: "practice/export/analysis/",

  //学校用户列表
  Schoollist: "admin/list/teacher",
  //查询所有学生
  studentlistGet: "admin/list/student",

  //实习过程插入
  processPut: "practice/process",
  //查询实习过程
  processGet: "practice/process/",
  //实习过程导出
  processPost: "practice/export/process/",

  //下载实习总结
  summaryDownPost: "practice/summary/download",
  //下载周日报收藏
  collectDownPost: "practice/collect/download",

  //公众号发送
  gongzhonghaofs: "teach/notice/",

  //获取二维码（公司）
  getqrcompany: "login/qrcode/company/",
  //获取二维码（学生）
  getqrstudent: "login/qrcode/student/",
  //学生二维码
  getStudentToCode: "admin/qrcode/",

  //实习指导
  guidanceGet: "practice/guidance/",
  //实习巡查
  patrolGet: "practice/patrol/",

  //查询所有学校
  schoolListGet: "admin/school/",
  //设置功能模块
  schoolModularPost: "admin/school",

  //更换用户头像
  updataUserJpg: "user/headPortrait",

  //添加年度
  addGrade: "years/list",
  //向学校中添加年度
  addSchoolGrade: "admin/year",

  //数字化大屏
  shuzihuadp: "admin/data",

  //查询打卡
  getClokin: "practice/getsign",

  //添加反馈
  addFeedback: "feedback/add",
  //获取反馈
  getFeedback: "feedback/get",
  //删除反馈
  deleteFeedback: "feedback/delete",

  //修改节假日
  GradeUpdate: "admin/timeLst",

  //新增学校数据库配置
  addDatabase: "admin/database",
  //查看学校数据库配置
  getDatabase: "admin/database",
  //删除学校数据库配置
  deleteDatabase: "admin/database/",

  //获取近七天打卡状态
  getTimeslotClick: "practice/getsign2",
  //获取近七天日报状态
  getDailyLog: "practice/getDailyLog",
  //获取近七天周报状态
  getWeekLog: "practice/getWeekLog",
  // 获取档案管理数据
  getFiles: "practice/getFiles",
  // 下载日报
  downloadDailyLog: "practice/downloadDailyLog",
  // 下载周报
  downloadWeekLog: "practice/downloadWeekLog",
  // 下载考勤
  downloadSignLog: "practice/downloadSignLog",
  // 通过组织或者班级获取学生信息
  stuInfo: "practice/getPracticePosition",
  exportClass: "practice/exportClass",
  getseachData: "practice/serachCompany",
  getAllClass: "admin/getAllClass",
  exportUser: "user/update",
  getTeacherLog: "practice/getTeacherLog",
  downloadTeacher: "practice/downloadTeacherLog",
  exportApply: "practice/exportApply",
  exportUninvite: "practice/exportUninvite",
  getUnlnvitePosition: "practice/getUnInvitePosition",
  getModify: "stu/getModify",
  exportSign2: "position/exportSign2",
  exportSign: "practice/exportSign",
  searchStudent: "class/searchStudent",
  cancelSummary: "admin/cancelSummary",
  getClassStudent: "position/getClassStudent",
  removeOpenid: "position/removeOpenid",
  getTeacherClass: "position/getTeacherClass",
  quitClass: "position/quitClass",
  getAdminStudent: "position/getAdminStudent",
  updateApply: "position/updateApply",
  getApply: "position/getApply",
  changeClassStatus: "position/changeClassStatus",
  getClassId: "position/getClassId/",
  getAllStudent: "position/getAllStudent",
  getSign1: "position/getSign",
  getLeave: "position/getLeave",
  refuseLeave: "position/refuseLeave",
  getSignRange: "position/getSignRange",
  process: "position/process",
  destination: "position/destination",
  getLog: "position/getDayLog",
  getWeekLog: "position/getWeekLog",
  refuseLog: "position/refuseLog",
  getStudentWeekLog: "position/getStudentWeekLog",
  signAbnormal: "position/signAbnormal",
  getArchives1: "position/getArchives",
  getGuidance: "position/getGuidance",
  getPatrol: "position/getPatrol",
  getStudentArchives: "position/getStudentArchives",
  getDisperse: "position/getDisperse",
  updateDisperseStatus: "position/updateDisperseStatus",
  exportDisperse: "position/exportDisperse"
};



// WEBPACK FOOTER //
// ./src/api/apiUrl.js